
import React, { Component } from 'react';

import "@arco-design/web-react/dist/css/arco.css";
import { Form, Input, Layout, Empty, Space, Card, Carousel, Button, Select, Modal, Tabs, Descriptions } from '@arco-design/web-react';

import * as utils from "../utils.js"
import ScaledImage from '../comp/my-img';
import MyComp from '../comp/my-comp.js';
import { IconFilePdf, IconSearch } from '@arco-design/web-react/icon';
import * as news_config from '../common/news_config'
import { QRCodeSVG } from 'qrcode.react';
import './classroom.css';


const Option = Select.Option;
const FormItem = Form.Item;
const InputSearch = Input.Search;
const TabPane = Tabs.TabPane;


export default class App extends MyComp {
  constructor(props) {
    super(props);

    this.ref_form = React.createRef();
    let yearList = [2020, 2021, 2022, 2023, 2024]
    yearList.sort((a, b) => { return b - a })

    this.allList = news_config.getNewsList()

    this.state = {
      yearList: yearList,
      newsList: [],

      formInfo: {
        year: undefined,
        searchVal: '',
      },
      winWidth: 0,
      winHeight: 100,
      language: this.props.language || 'ch'
    }


  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize()
    // this.getData()

  }
  componentWillReceiveProps(nextProps) {
    console.log(nextProps)
    this.allList = news_config.getNewsList(nextProps.language)
    this.setState({
      language: nextProps.language
    })
  }
  // getData(){
  //   let {formInfo} = this.state
  //   let reqData = {
  //     op: 'getNews',
  //     year: formInfo.year,
  //     searchVal: formInfo.searchVal
  //   }
  //   let successFunc = (rsp)=>{
  //     console.log(rsp)
  //     this.initNews()
  //   }
  //   let failFunc = (rsp)=>{
  //     console.log(rsp)
  //     this.initNews()
  //   }
  //   utils.SendMsg(reqData, successFunc, failFunc)
  // }
  getTop() {
    let { winWidth } = this.state
    if (winWidth == 0) {
      return
    }

    let idx = 1
    let rate = winWidth / 1334
    let tipHeight = 667 * rate
    let tipWidth = 1269 * rate

    let { language } = this.props
    let languageFolder = utils.GetLanguageFolder(language)

    let urlbg = `../imgs/classroom/img_banner.png`
    let url_txt1 = `../imgs/classroom/img_tip_1.png`
    let url_txt2 = `../imgs/classroom/img_tip_2.png`

    console.log(winWidth, rate)
    return (<div style={{ width: '100vw', height: tipHeight }}>
      <div style={{ position: 'relative', }}>
        <img src={urlbg} style={{ width: '100vw', aspectRatio: 'auto', position: 'absolute', left: 0, top: 0, }} />
        <div style={{ position: 'absolute', left: '4vw', top: '4vw', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
          <ScaledImage src={url_txt2} rate={rate * 0.2}></ScaledImage>
        </div>


        <div style={{ width: winWidth, height: tipHeight, position: 'absolute', left: '0', top: '10vw' }}>
          <ScaledImage src={url_txt1} rate={rate * 0.7} style={{ margin: '0 auto' }}></ScaledImage>
        </div>
      </div>
    </div>
    )
  }
  getMid() {
    let { winWidth } = this.state
    if (winWidth == 0) {
      return
    }

    let idx = 1
    let rate = winWidth / 1334
    let tipHeight = 931 * rate
    let tipWidth = 1269 * rate
    let dlt = 1334 * 0.1 / 100 * rate

    let url_txt3 = `../imgs/classroom/img_tip_3.png`
    console.log(dlt)
    return (
      <div style={{ width: 1334 * rate * 1 }}>
        {/* <div style={{backgroundColor: 'green', width: 1334*rate*0.9, height: 50, margin: '20px auto'}}></div> */}
        <ScaledImage src={url_txt3} rate={rate * 0.95} style={{
          margin: '20px auto'
        }}></ScaledImage>
      </div>

    )
  }
  getBot() {
    let { winWidth } = this.state
    if (winWidth == 0) {
      return
    }

    let idx = 1
    let rate = winWidth / 1334
    let tipHeight = 931 * rate
    let tipWidth = 1269 * rate

    let url_txt1 = `../imgs/classroom/img_step1.png`
    let url_txt2 = `../imgs/classroom/img_step2.png`
    let url_txt3 = `../imgs/classroom/img_step3.png`
    let url_txt4 = `../imgs/classroom/img_step4.png`

    let url_tip4 = `../imgs/classroom/img_tip_4.png`

    let url_fee1 = `../imgs/classroom/img_fee1.jpg`
    let url_fee2 = `../imgs/classroom/img_fee2.jpg`
    let url_fee3 = `../imgs/classroom/img_fee3.jpg`
    let url_qr = `../imgs/classroom/qr.png`

    let url_qa1 = `../imgs/classroom/img_qa1.jpeg`
    let url_qa2 = `../imgs/classroom/img_qa2.jpeg`
    let url_qa3 = `../imgs/classroom/img_qa3.jpeg`
    let url_qa4 = `../imgs/classroom/img_qa4.jpeg`

    let data1 = [
      {
        label: <ScaledImage src={url_txt1} rate={1} width={50} height={50}></ScaledImage>,
        value: <Space direction='vertical' align='start'>
          <span>请务必阅读使用条款</span>
          <Space>
            <span className='pdf-text' onClick={() => { utils.openUrl('../imgs/classroom/20250501agreement.pdf') }}><IconFilePdf />音乐厅服务协议</span>
            <span className='pdf-text' onClick={() => { utils.openUrl('../imgs/classroom/20250501rule.pdf') }}><IconFilePdf />音乐厅使用管理规定</span>
            <span className='pdf-text' onClick={() => { utils.openUrl('../imgs/classroom/20250501duty.pdf') }}><IconFilePdf />消防安全责任书</span>
          </Space>
        </Space>,
      },
      {
        label: <ScaledImage src={url_txt2} rate={1} width={50} height={50}></ScaledImage>,
        value: <Space direction='vertical' align='start'>
          <span>请查看费用清单</span>
          <Space>
            <span className='pdf-text' onClick={() => { utils.openUrl('../imgs/classroom/20250501intro.pdf') }}><IconFilePdf />光之巨石阵音乐厅介绍</span>
          </Space>
        </Space>,
      },
      {
        label: <ScaledImage src={url_txt3} rate={1} width={50} height={50}></ScaledImage>,
        value: <Space direction='vertical' align='start'>
          <span>如有意向请致电音乐厅租赁部:13982194888(微信同号)</span>
        </Space>,
      },
      {
        label: <ScaledImage src={url_txt4} rate={1} width={50} height={50}></ScaledImage>,
        value: <Space direction='vertical' align='start'>
          <span>与您沟通活动细节并签署合同，确认后将收取费用</span>
        </Space>,
      },
    ]
    return (
      <Tabs type='card-gutter' style={{ paddingLeft: '1vw', paddingRight: '1vw' }}>
        <TabPane key='1' title='概述' style={{ justifyContent: 'flex-start', textAlign: 'left', paddingLeft: 20 }}>
          <Descriptions
            column={1}
            title='如何申请'
            data={data1}
            style={{ marginBottom: 20 }}
            labelStyle={{ marginLeft: 0, }}
          />
          <ScaledImage src={url_tip4} rate={rate * 0.6} style={{ paddingTop: '4vw', paddingBottom: '4vw' }}></ScaledImage>
          <ScaledImage src={url_qr} rate={rate * 0.6} style={{ paddingTop: '4vw', paddingBottom: '4vw', paddingLeft: 20 }}></ScaledImage>
          {/* <QRCodeSVG 
              value='https://sndviolin.com/classroom'
              size={128}
              level="H"
              includeMargin
            /> */}
        </TabPane>
        <TabPane key='2' title='费用' style={{ justifyContent: 'center', textAlign: 'left' }}>
          <Space direction='vertical' >
            <ScaledImage src={url_fee1} rate={Math.min(rate * 0.95, 0.7)} style={{ paddingBottom: 20 }}></ScaledImage>
            <ScaledImage src={url_fee2} rate={Math.min(rate * 0.95, 0.7)} style={{ paddingBottom: 20 }}></ScaledImage>
            <ScaledImage src={url_fee3} rate={Math.min(rate * 0.95, 0.7)} style={{ paddingBottom: 20 }}></ScaledImage>
          </Space>
        </TabPane>
        <TabPane key='3' title='常见问题' style={{ justifyContent: 'center', textAlign: 'left' }}>
          <Space direction='vertical'>
            <ScaledImage src={url_qa1} rate={Math.min(rate * 0.95, 0.8)} style={{ paddingBottom: 20 }}></ScaledImage>
            <ScaledImage src={url_qa2} rate={Math.min(rate * 0.95, 0.8)} style={{ paddingBottom: 20 }}></ScaledImage>
            <ScaledImage src={url_qa3} rate={Math.min(rate * 0.95, 0.8)} style={{ paddingBottom: 20 }}></ScaledImage>
            <ScaledImage src={url_qa4} rate={Math.min(rate * 0.95, 0.8)} style={{ paddingBottom: 20 }}></ScaledImage>
          </Space>
        </TabPane>
      </Tabs>
    )
  }
  getBody() {
    return (
      <Space size={0} direction='vertical'
        // align='start'
        style={{
          // paddingTop: '4vw', paddingBottom: '4vw',
          // ,marginLeft:'3vw', marginTop: '6vw', marginBottom: '6vw'
        }}>
        {this.getTop()}
        {this.getMid()}
        {this.getBot()}
      </Space>
    )
  }
  render() {
    return (
      <div>
        {this.getBody()}
      </div>
    );
  }
}

